export function clearSearchStorage(storage) {
  try {
    const keys = [];
    for (let i = 0; i < storage.length; i++) {
      const key = storage.key(i);
      if (key === 'search-data' || key === 'search-params' || key.startsWith('onk:legacy-search:')) keys.push(key);
    }
    keys.forEach(key => storage.removeItem(key));
  } catch (_) { /* Browser storage is optional. */ }
}

export function readFailure(error, fallback = 'Не удалось загрузить данные. Повторите запрос.') {
  const keys = Object.keys(error && error.response && error.response.data && error.response.data.error || {});
  if (keys.includes('auth_required')) return 'Сессия истекла. Войдите снова.';
  if (keys.includes('access_required')) return 'Для этого раздела нужен действующий доступ.';
  if (keys.includes('incomplete_recipe')) return 'Рецепт временно недоступен.';
  if (keys.includes('recipe_unavailable')) return 'Этот рецепт удалён или недоступен.';
  if (keys.includes('incomplete_menu')) return 'Меню временно недоступно.';
  if (keys.includes('csrf_expired')) return 'Не удалось сохранить. Повторите попытку.';
  return fallback;
}

export function installSafeDiagnostics(Vue, target, sink) {
  const report = (level, values) => {
    const metadata = values.map(value => ({
      kind: value instanceof Error ? value.name : typeof value,
      status: Number(value && value.response && value.response.status) || undefined,
    }));
    // Never pass request configuration, message, URL, token, body or user data.
    sink[level]('[Legacy application]', metadata);
  };
  target.console.error = (...values) => report('error', values);
  target.console.warn = (...values) => report('warn', values);
  Vue.config.errorHandler = error => report('error', [error]);
  target.addEventListener('unhandledrejection', event => {
    report('error', [event.reason]);
    event.preventDefault();
  });
}
